import api from './apiClient';

export interface ExchangeRateResponse {
  success: boolean;
  source?: string;
  effectiveDate?: string | null;
  requestedDate?: string | null;
  lookupDate?: string | null;
  estimated?: boolean;
  cached?: boolean;
  stale?: boolean;
  message?: string;
  rates?: Array<{
    code: string;
    currency: string;
    mid: number;
    effectiveDate: string;
  }>;
}

type PayablesResponse = {
  success?: boolean;
  payables?: unknown[];
  [key: string]: unknown;
};

export const payablesAPI = {
  getPayables: async (params?: {
    month?: string; // YYYY-MM
    status?: 'nieopłacone' | 'częściowo' | 'opłacone' | 'przeterminowane' | 'anulowane';
    archived?: 0 | 1;
  }): Promise<PayablesResponse> => {
    const response = await api.get('/payables', { params });
    return response.data;
  },
};

export const paymentsAPI = {
  markPaid: async (payableId: number, data: { paidAt?: string; paymentMethod?: 'przelew' | 'karta' | 'gotówka' | 'split'; transactionRef?: string }): Promise<{ success?: boolean; [key: string]: unknown }> => {
    const response = await api.post(`/payments/mark-paid/${payableId}`, data || {});
    return response.data;
  },
};


export const exchangeRatesAPI = {
  getNbpRates: async (codes: string[] = ['EUR', 'USD'], date?: string): Promise<ExchangeRateResponse> => {
    const response = await api.get('/exchange-rates/nbp', {
      params: {
        codes: codes.join(','),
        ...(date ? { date } : {})
      }
    });
    return response.data;
  }
};
